/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * Tabs.
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module
	 * @class Tabs
	 * @extends Tc.Module
	 */
	Module.Tabs = Module.extend({
		// True if tracking is enabled
		enableTracking: false,
		// True if lazy tab contents should be cached
		enableCaching: true,
		// True if tabs should be loaded lazily (in general – individual tabs can still be static (for example if they’re loaded initially))
		// Currently unused as the jQuery UI tabs detect the type of link for this
		enableLazyLoading: false,
		// All the LIs that make up the tab headings
		tabHeadings: null,
		// The tab currently selected: {tab, panel}
		selectedTab: null,
		// Whether we generate the mobile helper links at the bottom
		createBottomLinks: false,

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var $ctx = this.$ctx;

			this.createBottomLinks = $ctx.data('create-mobile-links') && $('body').hasClass('is-mobile');

			this.setupAnimations();

			this.enableTracking = $ctx.data('enableTracking');
			this.enableCaching = $ctx.data('enableCaching');
			this.enableLazyLoading = $ctx.data('enableLazyLoading');
			this.scroller = $ctx.find('> .scroll-wrapper > .scroller')[0];
			var $headingParent = this.scroller ? $(this.scroller) : $ctx;
			this.tabHeadings = $headingParent.find('> ul > li');
			this.setupTabs($ctx);
			this.setupAPI($ctx);

			this.tabs = this.$ctx.find('.tab-list .ui-tabs-anchor');

			if (this.createBottomLinks) {
				Module.Tabs.initBottomTabLinks(this, '.tab-title');
				this.hideActiveBottomTabLink($(this.selectedTab.tab).find('.ui-tabs-anchor'));
			}
			callback();
		},

		/**
		 * Called when all modules have been set up
		 */
		after: function () {
		},

		/**
		 * Do nothing in default implementation
		 * Left for overrides
		 */
		setupAnimations: function () {

		},

		setupTabs: function ($ctx) {
			var mod = this;

			var selectedTabs = mod.tabHeadings.filter('[data-is-selected="true"]').eq(0);
			if (selectedTabs.length === 0) {
				selectedTabs = mod.tabHeadings.eq(0);
			}

			var tabOptions = mod.getTabOptions(selectedTabs);

			$ctx.tabs(tabOptions);

			mod.initialTabSelection();

			var tabSelected = $ctx.tabs('option', 'active');
			var trackingTab = $ctx.find('ul li:nth-child(' + (tabSelected + 1) + ') a');
			var trackingVal = trackingTab.data('tracking-name');
			if (!trackingVal) {
				trackingVal = trackingTab.text();
			}
			SCS.tracking.setLandingTabName(trackingVal);
		},

		// Overridable
		getTabOptions: function(selectedTabs) {
			var mod = this;
			return {
				load: function (event, ui) {
					var panel = $(ui.panel);
					// fix for mobile => Move out of scroller
					if (mod.scroller && panel.parents().is(mod.scroller)) {
						$(mod.scroller).parent().parent().append(panel);
					}
					SCS.utils.initNewModules(panel);
				},
				// For jQuery UI 1.11
				active: mod.tabHeadings.index(selectedTabs),
				classes: {'ui-tabs-active': 'ui-tabs-selected'},
				beforeActivate: $.proxy(mod.tabSelecting, mod),
				beforeLoad: $.proxy(mod.beforeLoad, mod),
				activate: $.proxy(mod.tabSelected, mod),
				create: function (event, ui) {
					if (ui.tab && ui.panel) {
						mod.selectedTab = ui;
					}
				}
			};
		},

		/**
		 * Called when we know the initial tab and tabs have been set up
		 * Do nothing in default implementation
		 * Left for overrides
		 */
		initialTabSelection: function (tab) {
			// jshint unused: false
		},

		setupAPI: function ($ctx) {
			$ctx.data('tab-switch-to-prev', $.proxy(this.switchToPrev, this));
			$ctx.data('tab-switch-to-next', $.proxy(this.switchToNext, this));
			$ctx.data('tab-switch-to-tab', $.proxy(this.switchToSpecific, this));
			$ctx.data('tab-current-tab', $.proxy(this.currentTab, this));
			$ctx.data('tab-count', $.proxy(this.count, this));
			$ctx.data('tab-headings', $.proxy(this.allTabHeadings, this));
		},

		handleBottomTabClick: function (event, tab) {
			event.preventDefault();
			// Act as if the top tab was clicked
			tab.click();
			return false;
		},

		hideActiveBottomTabLink: function (tab) {
			if (!this.createBottomLinks || !this.bottomTabLinks) {
				return;
			}
			this.bottomTabLinks.children().show();
			var link = tab.data('bottom-tab-link');
			if (link) {
				link.hide();
			}
		},

		/**
		 * jQuery UI event listener.
		 *
		 * Normalizes arguments across jQuery UI versions (desktop/mobile)
		 * and delegates to `selectingTab`.
		 */
		tabSelecting: function (event, ui) {
			var tab = $(ui.tab || (ui.newTab && ui.newTab.find('a')));

			this.selectingTab(tab);
		},

		// Overridable
		selectingTab: function (tab) {
			if (this.enableTracking) {
				var trackingVal = tab.data('tracking-name');
				if (!trackingVal) {
					trackingVal = tab.html();
				}

				var parentTab = tab.parents('.modTabs').parents('.modTabs:last').find('li.ui-state-active a');
				if (typeof parentTab !== 'undefined') {
					var parentTrackingVal = parentTab.data('tracking-name');
					if (!parentTrackingVal) {
						parentTrackingVal = parentTab.html();
					}
					if (parentTrackingVal && parentTrackingVal !== '') {
						trackingVal = parentTrackingVal + '/' + trackingVal;
					}
				}
				this.log('selectingTab > trackingVal', trackingVal);
				SCS.tracking.trackPartialPageView(trackingVal);
			}
		},

		// Overridable
		beforeLoad: function (event, ui) {
			if(!this.enableCaching) {
				return;
			}
			if(ui.tab.data('loaded') ) {
				event.preventDefault();
				return;
			}
			ui.jqXHR.success(function() {
				ui.tab.data('loaded', true );
			});
		},

		tabSelected: function (event, ui) {
			var mod = this;

			this.selectedTab = {
				tab: ui.newTab,
				panel: ui.newPanel
			};

			mod.hideActiveBottomTabLink($(this.selectedTab.tab).find('.ui-tabs-anchor'));

			var panel = $(this.selectedTab.panel);


			$(document).trigger('element-shown', [panel]);
			$(window).trigger('resize'); // only for TabNavigations to initialize
			mod.$ctx.trigger('tabSelected', this.selectedTab.tab, panel);
		},

		switchToPrev: function () {
			this.tabHeadings.filter('.ui-tabs-selected').prev('li').find('a').click();
		},

		switchToNext: function () {
			this.tabHeadings.filter('.ui-tabs-selected').next('li').find('a').click();
		},

		switchToSpecific: function (tab) {
			if (!isNaN(parseInt(tab, 10))) {
				tab = this.tabHeadings.eq(tab);
			}
			if (this.tabHeadings.is(tab)) {
				tab = this.tabHeadings.filter(tab).eq(0);
				tab.find('a').click();
			}
		},

		currentTab: function () {
			return this.selectedTab;
		},

		allTabHeadings: function () {
			return this.tabHeadings;
		},

		count: function () {
			return this.tabHeadings.length;
		}
	});

	Module.Tabs.TAB_MODULE_SELECTOR = '.mod.modTabs';

	/**
	 * Searches the one tab control (if any) that should be affected by a keypress.
	 * @param selectMode either "prev" or "next"
	 */
	Module.Tabs.findAffectedTabControl = function (selectMode) {
		var validTabControls = $(Module.Tabs.TAB_MODULE_SELECTOR);
		// Reduce to elements whose selected panel is not yet the first (or last)
		validTabControls = validTabControls.filter(function () {
			var tabControl = $(this);
			var tab = tabControl.data('tab-current-tab')();
			var index = tab.index;
			if (selectMode === 'next') {
				var count = tabControl.data('tab-count')();
				return index !== (count - 1);
			} else {
				return index !== 0;
			}
		});
		// Exclude tab control contained in closed tab panels
		validTabControls = validTabControls.filter(':visible');
		// Reduce to that don’t contain other valid tabs
		validTabControls = validTabControls.filter(function () {
			var tabControl = $(this);
			var tab = tabControl.data('tab-current-tab')();
			var doesContainValidTabControls = false;
			validTabControls.each(function () {
				if ($(this).parents().is(tab.panel)) {
					doesContainValidTabControls = true;
					return false;
				}
			});
			return !doesContainValidTabControls;
		});
		if (!validTabControls.length) {
			return null;
		}
		return selectMode === 'next' ? validTabControls.first() : validTabControls.last();
	};

	Module.Tabs.switchTo = function (selectMode) {
		var tabControl = Module.Tabs.findAffectedTabControl(selectMode);
		if (!tabControl) {
			return false;
		}
		if (selectMode === 'next') {
			tabControl.data('tab-switch-to-next')();
		} else {
			tabControl.data('tab-switch-to-prev')();
		}
		return true;
	};

	Module.Tabs.setupKeyBindings = function () {
		$(document).keydown(function (e) {
			var target = $(e.target);
			if (target.is('input') || target.closest('form').length) {
				// we are inside an input field - don’t switch tabs!
				// we are somewhere inside a form - don’t switch tabs!
				return;
			}
			var hasMatched = false;
			if (e.which === 37) {
				hasMatched = Module.Tabs.switchTo('prev');
			} else if (e.which === 39) {
				hasMatched = Module.Tabs.switchTo('next');
			}
			if (!hasMatched) {
				return;
			}
			e.stopPropagation();
			$(document).one('keypress', function (e) {
				e.preventDefault();
			});
		});
	};

	Module.Tabs.initBottomTabLinks = function (mod, titleQuery) {
		mod.bottomTabLinks = mod.$ctx.nextAll('.bottom-tab-links').eq(0);

		if (!mod.bottomTabLinks.length) {
			return;
		}
		var fragment = document.createDocumentFragment();

		mod.tabs.each(function () {
			var tab = $(this);
			var li = document.createElement('li');
			var a = tab.clone(false).appendTo(li);
			if (titleQuery) {
				a.html(a.find(titleQuery).html());
			}
			a.addClass('tab-navigation-tab-mobile-link').removeClass('active');
			tab.data('bottom-tab-link', $(li));
			a.on('click tap', function (event) {
				return mod.handleBottomTabClick(event, tab);
			});
			fragment.appendChild(li);
		});
		mod.bottomTabLinks.append(fragment);
	};


	Module.Tabs.setupKeyBindings();
}(window.Tc.Module, window.Tc.$, window.SCS));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.js
// module id = 192
// module chunks = 0